// extracted by mini-css-extract-plugin
module.exports = {"card__container":"card_card__container__guvsV","dash__card":"card_dash__card__6_5MJ","dark__dash__card":"card_dark__dash__card__JFV4Q"};